import React, { useMemo } from 'react';
import { generateColor, getInitials } from '../../utils/validations';
import { RadioGroupItem } from '../ui/Radio';
import { ContactIcon, EmailIcon } from '../../icons';
import clsx from 'clsx';

const DriverInfoCard = ({ driverData, wrapperClass = '' }) => {
  const { firstName, lastName, id, email, phone } = driverData;
  const initials = getInitials(firstName, lastName);

  const background = useMemo(() => {
    return generateColor(firstName);
  }, [firstName]);

  return (
    <div
      className={clsx(
        'p-3 flex flex-col gap-4 bg-white rounded-xl lg:max-w-[350px] lg:w-full min-w-[300px] w-[300px]',
        wrapperClass
      )}
      style={{
        boxShadow: '0px 2px 6px 0px #63636333',
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h6
            className="rounded-full text-center min-w-[2.5rem] h-10 leading-10"
            style={{ background: background }}
          >
            {initials}
          </h6>
          <h6>
            {firstName} {lastName}
          </h6>
        </div>

        <RadioGroupItem value={driverData} id={id} />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-1.5">
          <EmailIcon />
          <span className="text-body">{email}</span>
        </div>
        <div className="flex gap-1.5">
          <ContactIcon />
          <span className="text-body">{phone}</span>
        </div>
      </div>
    </div>
  );
};

export default DriverInfoCard;
